import { OctContextMenu } from '@oceantech/oceantech-ui';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { RowMouseEventHandlerParams } from 'react-virtualized';
import { ConfirmDialog } from 'src/app/modules/component/ConfirmDialog';
import { GenerateFormModal } from 'src/app/modules/component/generate-form-modal';
import { ServiceTemplateButton } from 'src/app/modules/phan-he-kham-benh/components/service-template-button';
import { CONTEXT_MENU_CODE, SERVICE_CONTEXT_MENU_OPTIONS } from 'src/app/modules/phan-he-kham-benh/constants/ChiDinhDVConst';
import { SplitItemsModal } from 'src/app/modules/phan-he-kham-benh/modals/modal-chi-dinh-dich-vu/components/SplitItemsModal';
import { BASE_URL } from 'src/app/modules/phan-he-kham-benh/services/KhamBenhService';
import { MergedServiceRow, ServiceSplitHelper, SplitServiceItem } from 'src/app/modules/phan-he-kham-benh/utils/ServiceSplitHelper';
import { useDebounce } from '../../../../../_metronic/helpers';
import useWorkflowOrgConfig from '../../../../hook/useWorkflowOrgConfig';
import { KEY_LOCALSTORAGE } from '../../../auth/core/_consts';
import AutocompleteV2 from '../../../component/AutocompleteObjectV2';
import FormInPhieuDialog from '../../../component/button-in-phieu/components/PrintDialog';
import DatePickerCustom from '../../../component/date-picker/DatePickerCustom';
import { IconBack, IconButtonSave, IconMenu } from '../../../component/IconSvg';
import InputSearch from '../../../component/InputSearch';
import LabelRequired from '../../../component/LabelRequired';
import SelectTree from '../../../component/SelectTree';
import SimpleTable from '../../../component/table/simple-table/SimpleTable';
import { TableCustom } from '../../../component/table/table-custom/TableCustom';
import TextField from '../../../component/TextField';
import { IInPhieuParams } from '../../../models/params';
import ICD10 from '../../../phan-he-kham-benh/components/ICD10';
import InfoPatientRight from '../../../phan-he-kham-benh/components/InfoPatientRight';
import ProvisonalDiagnosis from '../../../phan-he-kham-benh/components/ProvisonalDiagnosis';
import { TreeChiDinhDichVu } from '../../../phan-he-kham-benh/constants/KhamBenh';
import { DsDichVuChiDinhColumn, dsDichVuColumnsSimple } from '../../../phan-he-kham-benh/modals/modal-chi-dinh-dich-vu/ChiDinhDichVuColumn';
import NgayKeTuDong from '../../../phan-he-kham-benh/modals/modal-ke-thuoc/components/NgayKeTuDong';
import { inPhieuChiDinhChung } from '../../../phan-he-kham-benh/services/PrintExportService';
import { handleConvertBenhNhanInfo } from '../../../phan-he-noi-tru/common/functionCommon';
import { CODE_DOI_TUONG } from '../../../phan-he-tiep-nhan-thanh-toan/constants/PhanHeTiepNhan';
import PaymentInfor from '../../../phan-he-vien-phi/components/PaymentInfor';
import { getPaymentDetail } from '../../../phan-he-vien-phi/services/PhanHeVienPhiServices';
import { handleSearchByFuse } from '../../../utils/AppFunction';
import { CODE, KEY_DS_DANH_MUC_TIEP_DON, OBS_COMPLEX_CATEGORY_CODE, ORDER_TYPE_ID, SELECTION_MODE, SIMPLE_CATEGORY_TYPE, TERM_CLASS_IDS, WORKFLOW_ORG_CONFIG_CODE } from '../../../utils/Constant';
import { formatDateDTO, formatDateTime, formatMoney } from '../../../utils/FormatUtils';
import { getIndexedDBItem } from '../../../utils/IndexedDB';
import { localStorageItem } from '../../../utils/LocalStorage';
import { getObsComplexCategory, getSimpleCategory, getTermClasses } from '../../../utils/ServicesUtils';
import { usePhanHeDieuTriNoiTruContext } from '../../PhanHeDieuTriContext';
import { getDsPhieuDieuTri } from '../../services/BenhAnServices';
import { getThongTinPhieuChiDinh } from '../../services/DieuTriServices';
import PhieuDieuTriDialog from '../benh-an/components/content/components/thong-tin-benh-an/components/phieu-dieu-tri/components/PhieuDieuTriDialog';

type Props = {
    phieuDieuTri?: any
    handleClose: () => void
    orderGroupId?: string
    selectedRows: any[]
    setSelectedRows: (data: any) => void
    [key: string]: any
}

const initThongTinChiPhi = {
    ttBhyt: 0,
    ttConNo: 0,
    ttConDu: 0,
    ttDaChi: 0,
    ttDaThu: 0,
    ttDiscountInv: 0,
    ttDiscountPercent: 0,
    ttNguoiBenh: 0,
    ttTamUng: 0,
    ttThucTe: 0,
    ttTong: 0,
};

const FormChiDinhDV = (props: Props) => {
    const { handleClose, phieuDieuTri, orderGroupId, selectedRows, setSelectedRows, orderGroupIds,
        isSaveAndPrint, openPrintDialog, sessionCode, setOpenPrintDialog
    } = props;
    const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();
    const { config: paymentConfig } = useWorkflowOrgConfig({
        code: WORKFLOW_ORG_CONFIG_CODE.FORM_INFO_PAYMENT_ASSIGN
    });

    const { values, setFieldValue, setValues, errors, touched, submitForm } = useFormikContext<any>();
    const [codeCollapses, setCodeCollapses] = useState<string[]>([]);
    const [idSelected, setIdSelected] = useState<string>("");
    const [treeData, setTreeData] = useState<any>(TreeChiDinhDichVu);
    const [listDichVu, setListDichVu] = useState<any[]>([]);
    const [listDichVuSearch, setListDichVuSearch] = useState<any[]>([]);
    const [listICD10, setListICD10] = useState<any>([]);
    const [textSearch, setTextSearch] = useState<string>("");
    const [listResponseService, setListResponseService] = useState<any>([]);
    const [listComorbidity, setListComorbidity] = useState<any[]>([]);
    const [shouldOpenModalSelectICD10, setShouldOpenModalSelectICD10] = useState<boolean>(false);
    const [openPhieuDieuTriDialog, setOpenPhieuDieuTriDialog] = useState<boolean>(false);
    const [paymentItem, setPaymentItem] = useState<any>([]);
    const [ttChiPhiBanDau, setTtChiPhiBanDau] = useState(initThongTinChiPhi);
    const [expenseObject, setExpenseObject] = useState(initThongTinChiPhi);
    const [openAdditionalInfoModal, setOpenAdditionalInfoModal] = useState(false);
    const [dsPhieuDieuTri, setDsPhieuDieuTri] = useState<any[]>([]);
    const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
    const [shouldOpenConfirmDeleteDialog, setShouldOpenConfirmDeleteDialog] = useState<boolean>(false);
    const [contextMenu, setContextMenu] = useState<null | {
        x: number;
        y: number;
    }>(null);
    const rowEditRef = useRef<any>(null);
    const [showSplitModal, setShowSplitModal] = useState(false);
    const [selectedMergedRow, setSelectedMergedRow] = useState<MergedServiceRow | null>(null);

    const categoriesRef = useRef<{
        configPriceObject: any[];
        objectTypes: any[];
    }>({
        configPriceObject: [],
        objectTypes: [],
    });

    const displayOrders = useMemo(() => {
        console.log('displayOrders:', {
            ordersCount: values?.orders?.length,
            sample: values?.orders?.[0],
        });
        return values?.orders || [];
    }, [values?.orders]);

    const currentVisitObjectType = {
        id: benhNhanDieuTri?.visitObjectTypeId,
        code: benhNhanDieuTri?.visitObjectTypeCode,
        name: benhNhanDieuTri?.visitObjectTypeName,
    };
    let currentUser = localStorageItem.get(KEY_LOCALSTORAGE.CURRENT_USER);
    const textSearchDebounce = useDebounce(textSearch.trim(), 300);

    useEffect(() => {
        initCategories();
        updatePageData();
    }, []);

    useEffect(() => {
        handleSearchByFuse(listDichVuSearch, textSearchDebounce ?? '', setListDichVu);
    }, [textSearchDebounce]);

    const handleConvertTreeData = (data: any[]) => {
        let convertedData: any[] = data.map((item, index) => {
            return {
                ...item,
                code: item?.code || item?.name,
                name: item?.name,
                ...(item?.terms &&
                    item?.terms?.length && {
                    filter: handleConvertTreeData(item?.terms || []),
                }),
            };
        });
        return convertedData;
    };

    const handleChangeEncounterDiagnosis = (name: string, value: any) => {
        setFieldValue("encounterDiagnosis", {
            ...values.encounterDiagnosis,
            [name]: value,
        });
    };

    const getTermsByClassId = (terms: any[], classId: number) => {
        return terms.find(term => term.terms.some((subTerm: any) => subTerm.classId === classId));
    };

    const initTreeData = (services: any[], termClassId: number) => {
        let listLoaiDichVu = [];

        switch (termClassId) {
            case TERM_CLASS_IDS.XET_NGHIEM:
                listLoaiDichVu.push(getTermsByClassId(services, TERM_CLASS_IDS.XET_NGHIEM));
                break;
            case TERM_CLASS_IDS.CDHA:
                listLoaiDichVu.push(getTermsByClassId(services, TERM_CLASS_IDS.CDHA));
                break;
            case TERM_CLASS_IDS.PTTT:
                listLoaiDichVu.push(getTermsByClassId(services, TERM_CLASS_IDS.PTTT));
                break;
            default:
                listLoaiDichVu = services || [];
                break;
        };

        const treeDataConverted = {
            code: "all",
            name: "Tất cả dịch vụ",
            icon: <IconMenu />,
            filter: handleConvertTreeData(listLoaiDichVu),
        };

        setTreeData(treeDataConverted);
    };

    const updatePageData = async () => {
        try {
            let termClassId = 0;
            if (orderGroupId) {
                let responsePhieu = await getThongTinPhieuChiDinh({
                    orderGroupId
                });
                termClassId = responsePhieu?.data?.data?.termClassId ?? 0;
                let orders =
                    responsePhieu?.data?.data?.svcItems?.map((item: any) => ({
                        ...(item?.term || {}),
                        fulfillDeptCode: item?.fulfillDeptCode,
                        fulfillDeptName: item?.fulfillDeptName,
                        samplingDeptCode: item?.samplingDeptCode,
                        samplingDeptName: item?.samplingDeptName,
                        notes: item?.notes,
                        visitObjectType: {
                            id: item?.objectTypeId,
                            code: item?.objectTypeCode,
                            name: item?.objectTypeName,
                        },
                        obs: item?.obs
                    })) || [];
                setValues?.({
                    ...values,
                    ...responsePhieu?.data?.data,
                    encounterDiagnosis: {
                        ...values?.encounterDiagnosis,
                        diagnosisCoded: responsePhieu?.data?.data?.diagnosisCoded,
                        diagnosisNonCoded: responsePhieu?.data?.data?.diagnosisNonCoded,
                        diagnosisCodedName: responsePhieu?.data?.data?.diagnosisCodedName,
                        diagnosisComorbidity: responsePhieu?.data?.data?.diagnosisComorbidity,
                        encounterDiagnosisId: responsePhieu?.data?.data?.encounterDiagnosisId
                    },
                    orders,
                    indicationTime: responsePhieu?.data?.data?.indicationTime,
                    treatmentSheet: {
                        id: responsePhieu?.data?.data?.treatmentSheetId,
                        prescriptionDate: responsePhieu?.data?.data?.treatmentSheetCreatedDate
                    },
                    patientId: responsePhieu?.data?.data?.patientId,
                    encounterId: responsePhieu?.data?.data?.encounterId,
                });
                handleSelectService(orders);
                setSelectedRows(orders);
            };

            await handleGetThongTinChiPhi();
            const responseDichVuChiDinh = await getListDichVu(orderGroupId ? termClassId : undefined);
            const dvKhamBenh = {
                ...responseDichVuChiDinh?.[0] ?? {},
                terms: responseDichVuChiDinh?.[0]?.terms?.map((item: any) => ({
                    ...item,
                    ...(item?.subs &&
                        item?.subs?.length && {
                        subs: item?.subs?.filter((itemSub: any) => !itemSub?.attributes?.orderSetCode),
                    }),
                }))
            };
            const listDichVuChiDinh = [dvKhamBenh, ...responseDichVuChiDinh?.slice(1)];
            initTreeData(listDichVuChiDinh, termClassId);
            setListResponseService(listDichVuChiDinh);

            let listDichVuFull = listDichVuChiDinh.flatMap((items: any) => items?.terms.flatMap((item: any) => item?.subs))
            setListDichVu(listDichVuFull);
            setListDichVuSearch(
                listDichVuChiDinh.flatMap((items: any) => items?.terms.flatMap((item: any) => item?.subs))
            );
        } catch (e) {
            console.error(e);
        }
    };

    const handleGetSelectedItem = (data: any) => {
        if (data) {
            setListDichVu(data?.subs || []);
            setListDichVuSearch(data?.subs || []);
            setTextSearch("");
        } else {
            //Khi click lần 2 vào loại dịch vụ đó thì set ds dịch vụ về full dịch vụ
            setListDichVu(
                listResponseService.flatMap((items: any) =>
                    items?.terms.flatMap((item: any) => item?.subs)
                )
            );
            setListDichVuSearch(listResponseService.flatMap((items: any) =>
                items?.terms.flatMap((item: any) => item?.subs)
            ));
        }
    };

    const handleRenderCell = (columnData: any, dataKey: string, rowData: any) => {
        const svcPrice =
            rowData?.attributes?.[
            getObjectPriceFieldConfig(benhNhanDieuTri?.visitObjectTypeCode)
            ] ?? 0;
        rowData = {
            ...rowData,
            svcFee: formatMoney(rowData?.attributes?.svcFee) || 0,
            svcFeeHospital: formatMoney(rowData?.attributes?.svcFeeHospital) || 0,
            svcFeeIns: formatMoney(rowData?.attributes?.svcFeeIns) || 0,
            svcQuantity: rowData?.attributes?.svcQuantity || 1,
            svcPrice: formatMoney(svcPrice),
            deptLaboratoryName: rowData?.attributes?.deptLaboratoryName,
        };
        if (typeof rowData.get === "function") {
            return rowData.get(dataKey);
        } else {
            return rowData[dataKey];
        }
    };

    const handleCaculateFee = (data: any) => {
        let objResult = {
            tong: ttChiPhiBanDau.ttTong || 0,
            benhNhan: ttChiPhiBanDau.ttNguoiBenh || 0,
            conNo: ttChiPhiBanDau.ttConNo || 0,
            conDu: ttChiPhiBanDau.ttConDu || 0
        };
        let tongChiPhi = 0;

        data?.forEach((item: any) => {
            const unitPrice =
                item?.attributes?.[getObjectPriceFieldConfig(item?.visitObjectType?.code)] ?? 0;
            const quantity = item?.attributes?.svcQuantity ?? 1;
            const price = unitPrice * quantity;
            tongChiPhi = tongChiPhi + Number(price);

            const conNo = ttChiPhiBanDau.ttTamUng + ttChiPhiBanDau.ttDaThu - (ttChiPhiBanDau.ttNguoiBenh + tongChiPhi);
            objResult = {
                tong: objResult.tong + Number(price),
                benhNhan: objResult.benhNhan + Number(price),
                conNo: conNo,
                conDu: conNo < 0 ? Math.abs(conNo) : 0
            };
        });
        return objResult;
    };

    const handleSelectService = (data: any) => {
        let result = data?.map((item: any) => ({
            ...item,
            visitObjectType: item?.visitObjectType || currentVisitObjectType
        })) || [];

        const objFee = handleCaculateFee(result);
        setExpenseObject({
            ...ttChiPhiBanDau,
            ttTong: objFee?.tong,
            ttNguoiBenh: objFee?.benhNhan,
            ttConNo: objFee?.conNo,
            ttConDu: objFee?.conDu || 0
        });
        setFieldValue?.("orders", result);
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): any => {
        const value = (event.target as HTMLInputElement).value;
        const newValue = value ? `'${value}` : '';
        setTextSearch(newValue);
    };

    const handleOnRowClickCheckbox = (rowData: any) => {
        if (!rowData) return;

        let _listData = [...listDichVu];
        _listData[rowData.index].isChecked = true;
        let updatedSelectedRows = [...selectedRows];
        const selectedItem = _listData[rowData.index];

        if (!rowData?.rowData?.isChecked) {
            updatedSelectedRows.push(selectedItem);
        } else {
            updatedSelectedRows = updatedSelectedRows.filter(
                (item: any) => item?.["code"] !== selectedItem?.["code"]
            );
        }

        let result = updatedSelectedRows?.map((item: any) => ({
            ...item,
            visitObjectType: item?.visitObjectType || currentVisitObjectType
        })) || [];

        const objFee = handleCaculateFee(result);
        setExpenseObject({
            ...ttChiPhiBanDau,
            ttTong: objFee?.tong,
            ttNguoiBenh: objFee?.benhNhan,
            ttConNo: objFee?.conNo,
            ttConDu: objFee?.conDu || 0
        });
        setFieldValue("orders", result);
        setListDichVu([..._listData]);
        setSelectedRows(result);
    }

    const handleOpenSelectICD10 = () => {
        setShouldOpenModalSelectICD10(true);
    };

    const handleChangeICD10 = (data: any) => {
        setFieldValue('encounterDiagnosis', {
            ...values?.encounterDiagnosis,
            ...data,
        });
    };

    const getListDichVu = async (termClassId?: string | number) => {
        try {
            const CLASS_IDS_DICH_VU = [
                TERM_CLASS_IDS.XET_NGHIEM,
                TERM_CLASS_IDS.CDHA,
                TERM_CLASS_IDS.PTTT,
                TERM_CLASS_IDS.VAN_CHUYEN,
                TERM_CLASS_IDS.NGAY_GIUONG_CHUYEN_KHOA,
                TERM_CLASS_IDS.DV_KHAC
            ].join(',');

            const { data } = await getTermClasses({ classIds: termClassId ?? CLASS_IDS_DICH_VU });

            if (CODE.SUCCESS === data?.code) {
                return data.data;
            }

            return [];
        } catch (error) {
            console.error(error);
            toast.error('Xảy ra lỗi khi lấy danh sách dịch vụ, vui lòng thử lại!');
        }
    };

    const handleGetThongTinChiPhi = async () => {
        try {
            const { data } = await getPaymentDetail(benhNhanDieuTri?.visitId);
            if (CODE.SUCCESS === data?.code) {
                setTtChiPhiBanDau({
                    ttBhyt: data?.data?.ttBhyt,
                    ttConNo: data?.data?.ttConNo,
                    ttConDu: data?.data?.ttConDu || 0,
                    ttDaChi: data?.data?.ttDaChi,
                    ttDaThu: data?.data?.ttDaThu,
                    ttDiscountInv: data?.data?.ttDiscountInv,
                    ttDiscountPercent: data?.data?.ttDiscountPercent,
                    ttNguoiBenh: data?.data?.ttNguoiBenh,
                    ttTamUng: data?.data?.ttTamUng,
                    ttThucTe: data?.data?.ttThucTe,
                    ttTong: data?.data?.ttTong,
                });
            }
        } catch (error) {
            console.error(error);
            toast.error('Xảy ra lỗi khi lấy thống tin chi phi, vui lòng thử lại!');
        }
    }

    const handleSetPaymentInfor = async (paymentConfig: any) => {
        const FORM_FIELD_CONFIG = [
            {
                code: "TONG_CHI_PHI",
                name: "Tổng chi phí",
                value: expenseObject?.ttTong || 0,
                type: "price",
                color: "text-danger"
            },
            {
                code: "BHYT",
                name: "BHYT",
                value: ttChiPhiBanDau?.ttBhyt || 0,
                type: "price",
            },
            {
                code: "NGUON_KHAC",
                name: "Nguồn khác",
                value: 0,
                type: "price",
            },
            {
                code: "BENH_NHAN",
                name: "Bệnh nhân",
                value: expenseObject?.ttNguoiBenh || 0,
                type: "price",
            },
            {
                code: "TAM_UNG",
                name: "Tạm ứng",
                value: ttChiPhiBanDau?.ttTamUng || 0,
                type: "price",
            },
            {
                code: "DA_THU",
                name: "Đã thu",
                value: ttChiPhiBanDau?.ttDaThu || 0,
                type: "price",
            },
            {
                code: "MIEN_GIAM",
                name: "Miễn giảm",
                value: ttChiPhiBanDau?.ttDiscountInv || 0,
                type: "price",
            },
            {
                code: "CON_NO",
                name: Number(expenseObject?.ttConDu) > 0 ? "Còn dư" : "Còn nợ",
                value: Number(expenseObject?.ttConDu) > 0 ? Number(expenseObject?.ttConDu) : Math.abs(Number(expenseObject?.ttConNo)) || 0,
                type: "price",
            },
        ]
        try {
            if (!paymentConfig) {
                setPaymentItem(FORM_FIELD_CONFIG);
                return;
            }

            const newArr: any[] = [];
            paymentConfig.forEach((item: any) => {
                const obj = FORM_FIELD_CONFIG.find((obj: any) => obj?.code === item);
                newArr.push(obj);
            });
            setPaymentItem(newArr);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        handleSetPaymentInfor(paymentConfig);
    }, [expenseObject, ttChiPhiBanDau, paymentConfig]);

    const updateRowData = (rowIndex: number, field: string, value: any) => {
        const tableData = [...selectedRows];
        const updatedList = tableData.map((row: any, index) => {
            if (index === rowIndex) {
                // If field is null, replace entire row with value
                if (field === null) {
                    return value;
                }
                // Otherwise, use normal config edit
                const editedValue = configEditValue(field, value);
                return {
                    ...row,
                    ...editedValue,
                };
            }
            return row;
        });
        setFieldValue('orders', updatedList);
        setSelectedRows(updatedList);
    };

    const configEditValue = (field: string, value: any) => {
        let fieldValue: Record<string, any> = {
            [field]: value,
        };
        const isInsurance = CODE_DOI_TUONG.BAO_HIEM === benhNhanDieuTri?.visitObjectTypeCode;

        switch (field) {
            case 'fulfillDepartment':
                fieldValue = {
                    fulfillDeptCode: value?.value,
                    fulfillDeptName: value?.name,
                };
                break;
            case 'sampleDepartment':
                fieldValue = {
                    samplingDeptCode: value?.value,
                    samplingDeptName: value?.name,
                };
                break;
            case 'isOwnExpenses':
                if (isInsurance) {
                    fieldValue = {
                        ...fieldValue,
                        visitObjectType: getObjectTypeOption(
                            value ? CODE_DOI_TUONG.VIEN_PHI : CODE_DOI_TUONG.BAO_HIEM
                        ),
                    };
                }
                break;

            default:
                fieldValue = {
                    [field]: value,
                };
                break;
        }
        return fieldValue;
    };

    const initCategories = async () => {
        try {
            const [indexDBData, objectTypeCategory, configPriceObject] = await Promise.all([
                getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON),
                getSimpleCategory({
                    type: SIMPLE_CATEGORY_TYPE.DOI_TUONG_DICH_VU,
                }),
                getObsComplexCategory({
                    path: BASE_URL,
                    code: OBS_COMPLEX_CATEGORY_CODE.CAU_HINH_GIA_DVKT,
                }),
            ]);
            setListICD10(indexDBData?.listICD10 || []);
            categoriesRef.current = {
                objectTypes: objectTypeCategory?.data?.data?.content ?? [],
                configPriceObject: configPriceObject?.data?.content ?? []
            };
        } catch (error) {
            console.error(error);
        }
    };

    const getObjectPriceFieldConfig = (objectTypeValue: any) => {
        const priceConfigField = categoriesRef.current.configPriceObject.find((config) => {
            return config.termObjectTypeCode === objectTypeValue
        })?.termAttributeField;

        if (!priceConfigField) return null;

        // eslint-disable-next-line no-new-func
        const calculatePriceFn = new Function('moment', `${priceConfigField}`);
        return calculatePriceFn(moment);
    };

    const getObjectTypeOption = (code: string) => {
        return categoriesRef.current.objectTypes.find((item: any) => item?.code === code);
    };

    const onMenuContextClick = (value: any) => {
        const CONTEXT_MENU_ACTION_MAP = {
            [CONTEXT_MENU_CODE.THONG_TIN_BO_SUNG]: () => setOpenAdditionalInfoModal(true),
        };

        CONTEXT_MENU_ACTION_MAP[value?.code]?.();
        setContextMenu(null);
    };

    const onSaveAdditionalRowData = (editedValue: any) => {
        const tableData = [...values.orders];
        const updatedList = tableData.map((row: any, index) => {
            if (index === rowEditRef.current.index) {
                return {
                    ...row,
                    obs: editedValue,
                };
            }
            return row;
        });
        setFieldValue("orders", updatedList);
        setSelectedRows(updatedList);
        rowEditRef.current = null;
        setOpenAdditionalInfoModal(false);
    };

    const getMauChiDinhParams = () => {
        const ORDER_TYPE = parseInt(ORDER_TYPE_ID.DV_DIEU_TRI);
        const tableData = (values?.orders || []).map((row: any) => {
            const { subs, ...rowData } = row ?? {};

            return {
                orderType: ORDER_TYPE,
                orderTemplate: JSON.stringify(rowData),
            };
        });

        return {
            orderType: ORDER_TYPE,
            orderTemplate: '',
            lstOrderSetMemebers: tableData,
        };
    };

    const onSelectMauChiDinh = (data: any) => {
        const tableTemplateValue = data.lstOrderSetMemebers?.map((row: any) => ({
            ...JSON.parse(row.orderTemplate),
        }));
        const terms = treeData.filter.map((node: any) => [...node.terms]).flat();
        const visitObjectType = {
            code: benhNhanDieuTri?.visitObjectTypeCode,
            name: benhNhanDieuTri?.visitObjectTypeName,
        };
        const tableData: any[] = [];

        tableTemplateValue?.forEach((row: any) => {
            const parentTerm = terms.find((term: any) => term.id === row.parentId);

            if (parentTerm) {
                const termRow = parentTerm.subs.find((sub: any) => sub.id === row.id);
                const isSelectedService = selectedRows.some((item) => item.id === termRow.id);

                if (termRow && !isSelectedService) {
                    tableData.push({
                        ...termRow,
                        ...row,
                        visitObjectType
                    })
                }
            }
        });

        setValues({
            ...values,
            orders: [
                ...(values.orders ?? []),
                ...tableData
            ],
        });
        setSelectedRows([
            ...selectedRows,
            ...tableData,
        ]);
    };

    const saveDonMauValidation = () => {
        if (!(values.orders || []).length) {
            toast.warn('Chưa có dịch vụ được chỉ định cho mẫu này');
            return false;
        }

        return true;
    };

    const handleDelete = () => {
        setShouldOpenConfirmDeleteDialog(true);
    };

    const handleConfirmDelete = () => {
        let newArr = [...(values?.orders || [])];
        if (selectedRowIndex || selectedRowIndex === 0) {
            newArr.splice(selectedRowIndex, 1);
        }
        setFieldValue("orders", newArr);
        setSelectedRows(newArr);
        const objFee = handleCaculateFee(newArr);
        setExpenseObject((currentExpenseObject: any) => ({
            ...currentExpenseObject,
            ttTong: objFee?.tong,
            ttNguoiBenh: objFee?.benhNhan,
            ttConNo: objFee?.conNo,
            ttConDu: objFee?.conDu || 0
        }));
        setShouldOpenConfirmDeleteDialog(false);
    };

    const handleUpdateSplitItems = (updatedItems: SplitServiceItem[]) => {
        const currentOrders = [...(values.orders || [])];
        const splitGroupId = updatedItems[0]?.splitGroupId;
        // Find the original row (the one with this ID, not splitGroupId)
        const originalRowIndex = currentOrders.findIndex(
            (item: any) => item.id === selectedMergedRow?.id
        );

        if (originalRowIndex !== -1) {
            // Update the original row: Keep as 1 row, but store split items in metadata
            const newOrders = [...currentOrders];
            newOrders[originalRowIndex] = {
                ...newOrders[originalRowIndex],
                // Store split items in metadata for later expansion on submit
                _splitItems: updatedItems,
                _hasSplitItems: true,
                attributes: {
                    ...newOrders[originalRowIndex].attributes,
                    svcQuantity: updatedItems.length, // Update quantity to match split items count
                },
            };
            setFieldValue("orders", newOrders);
            toast.success(`Đã cập nhật ${updatedItems.length} items`);
        }
        setShowSplitModal(false);
        setSelectedMergedRow(null);
    };

    const handleAdjustSplitQuantity = (splitGroupId: string, newQuantity: number) => {
        const currentOrders = [...(values.orders || [])];
        const adjustedOrders = ServiceSplitHelper.adjustSplitGroupQuantity(
            currentOrders,
            splitGroupId,
            newQuantity
        );
        setFieldValue("orders", adjustedOrders);
    };

    const handleViewSplitItems = (rowData: any) => {
        let mergedRow = rowData;

        // Priority 1: Check if row has stored split items from previous popup save
        if (rowData._hasSplitItems && rowData._splitItems) {
            console.log('handleViewSplitItems - Using stored split items:', {
                splitItems: rowData._splitItems.length,
            });

            mergedRow = {
                ...rowData,
                isMergedRow: true,
                splitGroupId: rowData._splitItems[0]?.splitGroupId,
                splitItems: rowData._splitItems,
                totalQuantity: rowData._splitItems.length,
            };
        }
        // Priority 2: Check if this is already a merged row (has splitItems)
        else if (rowData.isMergedRow && rowData.splitItems) {
            console.log('handleViewSplitItems - Already merged row:', {
                splitItems: rowData.splitItems.length,
            });
        }
        // Priority 3: Regular row with quantity > 1, create split items on the fly
        else {
            const quantity = rowData.attributes?.svcQuantity || 1;

            if (quantity > 1) {
                console.log('handleViewSplitItems - Creating split items for quantity:', quantity);

                // Create split items from this single row
                const splitGroupId = rowData.splitGroupId || ServiceSplitHelper.generateUUID();
                const splitItems = ServiceSplitHelper.createSplitItems(rowData, quantity);

                mergedRow = {
                    ...rowData,
                    isMergedRow: true,
                    splitGroupId,
                    splitItems,
                    totalQuantity: quantity,
                };
            }
        }
        setSelectedMergedRow(mergedRow);
        setShowSplitModal(true);
    };

    const handleGetDsPhieuDieuTri = async () => {
        try {
            const { data } = await getDsPhieuDieuTri({
                patientId: benhNhanDieuTri?.patientId,
                visitId: benhNhanDieuTri?.visitId,
                medicalRecordCode: benhNhanDieuTri?.medicalRecordCode,
            });
            if (data?.code === CODE.SUCCESS) {
                setDsPhieuDieuTri(data?.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (benhNhanDieuTri?.patientId && benhNhanDieuTri?.visitId && benhNhanDieuTri?.medicalRecordCode) handleGetDsPhieuDieuTri();
    }, [benhNhanDieuTri?.patientId, benhNhanDieuTri?.visitId, benhNhanDieuTri?.medicalRecordCode]);

    return (
        <div className="h-100">
            <Modal.Header className="py-3 header-modal">
                <div className="d-flex gap-6">
                    <div
                        className="d-flex align-items-center gap-3 cursor-pointer"
                        onClick={() => handleClose()}
                    >
                        <IconBack />
                        <span className="fw-500">Quay lại</span>
                    </div>
                    <ServiceTemplateButton
                        label="Mẫu chỉ định"
                        getSaveParams={getMauChiDinhParams}
                        orderType={parseInt(ORDER_TYPE_ID.DV_DIEU_TRI)}
                        onSelectMau={onSelectMauChiDinh}
                        onSaveValidationFn={saveDonMauValidation}
                        multiSelect
                        disabled={!!orderGroupId}
                    />
                </div>
                {benhNhanDieuTri ? (
                    <InfoPatientRight benhNhanInfo={handleConvertBenhNhanInfo(benhNhanDieuTri)} />
                ) : (
                    <div className="spaces h-65"></div>
                )}
            </Modal.Header>
            <Modal.Body className="py-6 px-0 spaces overflow-hidden spaces h-calc-vh-90">
                <div className="d-flex h-100">
                    <div className="spaces width-20 bg-white radius-2 d-flex flex-column">
                        <div className="spaces px-12 py-5 h-42">
                            <InputSearch
                                placeholder="Tìm kiếm"
                                handleChange={() => { }}
                                className="spaces h-32 pr-4 radius-3"
                            />
                        </div>
                        <SelectTree
                            className="w-100 py-2 ps-4 flex-grow-1 border border-top-0 overflow-auto"
                            codeCollapses={codeCollapses}
                            handleChangeCollapsesCode={setCodeCollapses}
                            idSelected={idSelected}
                            handleChangeSelectId={setIdSelected}
                            getSelectedItem={handleGetSelectedItem}
                            selectTree={treeData}
                        />
                    </div>
                    <div className="d-flex flex-column spaces width-80 bg-light radius-2">
                        <div className="spaces radius-2 p-10 border-top bg-white">
                            <div className="d-flex flex-wrap">
                                <div className="spaces W-235 mb-4">
                                    <DatePickerCustom
                                        label="Ngày y lệnh"
                                        name="prescriptionDate"
                                        labelClassName="ms-0 min-w-110px"
                                        value={values?.prescriptionDate}
                                        setDateValue={(date) => {
                                            setFieldValue("prescriptionDate", date);
                                        }}
                                        mode='date-time'
                                        errors={errors?.prescriptionDate}
                                        touched={touched?.prescriptionDate}
                                        disabled
                                    />
                                </div>
                                <div className="spaces d-flex position-relative align-items-start">
                                    <Button
                                        className="bg-white spaces min-w-100 py-0 pl-10 mb-3"
                                        onClick={handleOpenSelectICD10}
                                    >
                                        <u className="fw-bold text-pri fs-13px">Chọn bệnh</u>
                                    </Button>
                                    <LabelRequired label="Chẩn đoán" isRequired className="min-w-90px" />
                                </div>
                                <Row className="flex-grow-1 position-relative">
                                    <ProvisonalDiagnosis
                                        encounterDiagnosisValues={values?.encounterDiagnosis}
                                        encounterDiagnosisErrors={(errors?.encounterDiagnosis as FormikErrors<any>)}
                                        encounterDiagnosisTouched={(touched?.encounterDiagnosis as FormikTouched<any>)}
                                        listComorbidity={listComorbidity}
                                        setListComorbidity={setListComorbidity}
                                        onChange={handleChangeICD10}
                                        handleChangeEncounterDiagnosis={handleChangeEncounterDiagnosis}
                                        icd10Field='diagnosisCoded'
                                        comorbidityField='diagnosisComorbidity'
                                    />
                                </Row>
                            </div>
                            <div className="w-100 d-flex spaces mt-2">
                                <div className="flex-grow-1 position-relative">
                                    <TextField
                                        label="Bệnh kèm theo"
                                        className="spaces w-100"
                                        inputClassName="w-100 spaces pr-40"
                                        name="diagnosisComorbidity"
                                        value={values?.encounterDiagnosis?.diagnosisComorbidity || ""}
                                        onChange={(e: any) =>
                                            handleChangeEncounterDiagnosis(e.target.name, e.target.value)
                                        }
                                        labelClassName="ms-0 min-w-110px"
                                    />
                                </div>
                                <div className="spaces W-310 mb-4 ml-10">
                                    <TextField
                                        label="BS điều trị"
                                        name="bacSiDieuTri"
                                        type="text"
                                        value={currentUser?.name || ""}
                                        labelClassName="ms-0 min-w-85px"
                                        disabled
                                    />
                                </div>
                            </div>

                            <Row>
                                <Col sm={5}>
                                    <div className='d-flex align-items-center'>
                                        <LabelRequired
                                            label="Phiếu điều trị:"
                                            className="spaces min-w-110"
                                            isRequired
                                        />
                                        <div className="spaces min-w-250">
                                            <AutocompleteV2
                                                options={dsPhieuDieuTri || []}
                                                getOptionLabel={option => formatDateTime(option?.prescriptionDate) as string}
                                                value={values?.treatmentSheet || phieuDieuTri}
                                                name="treatmentSheet"
                                                onChange={selectedOption => setValues({
                                                    ...values,
                                                    treatmentSheet: selectedOption,
                                                    prescriptionDate: formatDateDTO(selectedOption?.prescriptionDate)
                                                })}
                                                className="autocomplete-custom-tiep-nhan radius spaces h-29"
                                                errors={errors?.treatmentSheet}
                                                touched={touched?.treatmentSheet}
                                            />
                                        </div>
                                        <Button
                                            variant='link'
                                            className='link-info text-decoration-underline spaces py-0 pl-10'
                                            onClick={() => setOpenPhieuDieuTriDialog(true)}
                                        >
                                            Thêm phiếu điều trị
                                        </Button>
                                    </div>
                                </Col>
                                <Col sm={7}>
                                    <TextField
                                        className="spaces"
                                        inputClassName="w-100"
                                        label="Ghi chú"
                                        name="notes"
                                        value={values?.encounterDiagnosis?.notes || ""}
                                        onChange={(e: any) =>
                                            handleChangeEncounterDiagnosis(
                                                e.target.name,
                                                e.target.value
                                            )
                                        }
                                        labelClassName="spaces mr-4"
                                    />
                                </Col>
                                {!orderGroupId && (
                                    <Col sm={12} className="mt-1">
                                        <NgayKeTuDong name="autoPrescriptions" treatmentId={benhNhanDieuTri?.treatmentId} />
                                    </Col>
                                )}
                            </Row>
                        </div>
                        <div className="spaces flex-grow-1 bg-white px-0 radius-2 mt-6 table-ke-thuoc">
                            <div className="d-flex flex-column spaces width-100 bg-light h-100">
                                <div className="bg-white">
                                    <div className="px-10 py-5 h-35 spaces">
                                        <InputSearch
                                            placeholder="Tìm kiếm"
                                            handleChange={handleChange}
                                            className="spaces h-25 pr-4 radius-3"
                                        />
                                    </div>
                                    <div className="min-h-180 spaces bg-white mb-6">
                                        <SimpleTable
                                            data={listDichVu || []}
                                            columns={dsDichVuColumnsSimple}
                                            height={180}
                                            width={1000}
                                            scrollable={true}
                                            type={SELECTION_MODE.MULTI_TABLE}
                                            setDataChecked={handleSelectService}
                                            dataChecked={values?.orders || []}
                                            handleRenderCell={handleRenderCell}
                                            onRowClick={(rowData: RowMouseEventHandlerParams) => {
                                                handleOnRowClickCheckbox(rowData);
                                            }}
                                            keySearch={textSearchDebounce}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex flex-column flex-grow-1 mt-2 bg-white">
                                    <div className="d-flex spaces pt-10 pb-6 px-10 text-pri fw-bold">
                                        Phiếu chỉ định
                                    </div>
                                    <div className="flex-grow-1 spaces h-calc-vh-750">
                                        <TableCustom
                                            columns={DsDichVuChiDinhColumn}
                                            data={displayOrders || []}
                                            height={220}
                                            tableOptions={{
                                                updateRowData,
                                                listDoiTuong: categoriesRef.current.objectTypes,
                                                setSelectedRow: setSelectedRowIndex,
                                                handleDelete,
                                                getObjectPriceFieldConfig,
                                                adjustSplitQuantity: handleAdjustSplitQuantity,
                                                onViewSplitItems: handleViewSplitItems,
                                            }}
                                            handleContextMenu={(e, row) => {
                                                setContextMenu({
                                                    x: e.clientX,
                                                    y: e.clientY,
                                                });
                                                rowEditRef.current = {
                                                    ...row.original,
                                                    index: row.index,
                                                };
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between spaces px-10 mt-6 bg-white">
                                    <PaymentInfor
                                        className="flex-1 price-info"
                                        paymentData={paymentItem}
                                    />
                                    <div className="d-flex align-items-center spaces gap-10">
                                        <Button
                                            type="submit"
                                            className="btn-outline min-w-100px"
                                            onClick={() => {
                                                isSaveAndPrint.current = true;
                                            }}
                                        >
                                            <i className="bi bi-printer" />
                                            Lưu và in
                                        </Button>
                                        <Button className="btn-fill min-w-100px" type="submit">
                                            <IconButtonSave /> Lưu
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <ICD10
                shouldOpenModalSelectICD10={shouldOpenModalSelectICD10}
                setShouldOpenModalSelectICD10={setShouldOpenModalSelectICD10}
                listICD10={listICD10}
                listComorbidity={listComorbidity}
                setListComorbidity={setListComorbidity}
                selectionModeICD10="radio"
                data={values?.encounterDiagnosis}
                onChange={handleChangeICD10}
                icd10Field='diagnosisCoded'
                comorbidityField='diagnosisComorbidity'
            />

            <ConfirmDialog
                className="z-index-1060"
                show={shouldOpenConfirmDeleteDialog}
                title="Thông báo"
                message="Bạn có chắc chắn muốn bỏ dịch vụ này không ?"
                yes="Xác nhận"
                close="Đóng"
                onCloseClick={() => setShouldOpenConfirmDeleteDialog(false)}
                onYesClick={() => handleConfirmDelete()}
            />

            {openPhieuDieuTriDialog && (
                <PhieuDieuTriDialog
                    open={openPhieuDieuTriDialog}
                    onClose={() => setOpenPhieuDieuTriDialog(false)}
                    callbackFunc={(data: any) => setValues({
                        ...values,
                        treatmentSheet: data,
                        prescriptionDate: formatDateDTO(data?.prescriptionDate)
                    })}
                />
            )}

            {openPrintDialog && orderGroupIds?.length && sessionCode && (
                <FormInPhieuDialog<IInPhieuParams>
                    show={openPrintDialog}
                    onHide={() => {
                        handleClose();
                        setOpenPrintDialog(false);
                    }}
                    fetchExport={inPhieuChiDinhChung}
                    params={{
                        visitId: benhNhanDieuTri?.visitId,
                        patientId: benhNhanDieuTri?.patientId,
                        orderGroupId: orderGroupIds?.[0],
                        sessionCode
                    }}
                />
            )}

            {contextMenu && (
                <OctContextMenu
                    handleClickOptionContextMenu={onMenuContextClick}
                    handleCloseMenu={() => setContextMenu(null)}
                    data={SERVICE_CONTEXT_MENU_OPTIONS}
                    target={contextMenu}
                />
            )}

            {openAdditionalInfoModal &&
                <GenerateFormModal
                    title="Thông tin bổ sung dịch vụ"
                    termModel="service-additional-info"
                    open={openAdditionalInfoModal}
                    onClose={() => setOpenAdditionalInfoModal(false)}
                    onSave={onSaveAdditionalRowData}
                    itemEdit={rowEditRef.current}
                />
            }

            {showSplitModal && selectedMergedRow && (
                <SplitItemsModal
                    show={showSplitModal}
                    onClose={() => {
                        setShowSplitModal(false);
                        setSelectedMergedRow(null);
                    }}
                    mergedRow={selectedMergedRow}
                    onUpdateItems={handleUpdateSplitItems}
                    categoriesRef={categoriesRef}
                    getObjectPriceFieldConfig={getObjectPriceFieldConfig}
                    configEditValue={configEditValue}
                />
            )}
        </div>
    );
}

export default FormChiDinhDV;
